import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "15",
      height: "15",
      x: ".5",
      y: ".5",
      stroke: "currentColor",
      "stroke-width": "2",
      rx: "3.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.416 8.65H9.177v2.906H7.683V8.649H4.444V7.367h3.239V4.444h1.494v2.923h3.239z"
    }, null, -1)
  ]))]))
}
export default { render: render }